<div class="app-search-table" *ngIf="isTableRefreshed && filteredDs && filteredDs.data.length > 0">
  <app-table-data [pageSize]="pageSizeOptions" [dataSource]="filteredDs" [columns]="TABLE_COLUMNS"
    [tableConfig]="tableConfig" [localFilterConfig]="localFilterConfig"
    (onApplicationLinkClicked)="openApplication($event)">
  </app-table-data>
</div>